export default __webpack_public_path__ + "static/media/avatar_alison3.e6879f80.mp3";